// Lib imports
import axios from 'axios'

// Export a plugin function that takes the app instance
export default {
  install: (app) => {
    app.config.globalProperties.$http = axios
  }
}
